// src/utils/phoneUtils.ts
import {
  parsePhoneNumber,
  isValidPhoneNumber,
  getCountryCallingCode
} from "libphonenumber-js";
function normalizePhone(phone, defaultCountry = "ES") {
  const cleaned = phone.replace(/\s+/g, "").trim();
  try {
    const parsed = parsePhoneNumber(cleaned, defaultCountry);
    if (!parsed || !parsed.isValid()) {
      throw new Error("Invalid phone number");
    }
    return parsed.format("E.164");
  } catch {
    throw new Error("Invalid phone number format");
  }
}
function validatePhone(phone, defaultCountry = "ES") {
  try {
    return isValidPhoneNumber(phone, defaultCountry);
  } catch {
    return false;
  }
}
function getCallingCode(country) {
  try {
    return getCountryCallingCode(country);
  } catch {
    return "34";
  }
}
function parsePhone(phone, defaultCountry = "ES") {
  try {
    const parsed = parsePhoneNumber(phone, defaultCountry);
    if (!parsed || !parsed.isValid()) {
      return null;
    }
    return {
      countryCode: parsed.countryCallingCode,
      nationalNumber: parsed.nationalNumber,
      e164: parsed.format("E.164")
    };
  } catch {
    return null;
  }
}
function detectCountryFromLocale(locale) {
  const parts = locale.split("-");
  if (parts.length >= 2) {
    const country = parts[1].toUpperCase();
    try {
      getCountryCallingCode(country);
      return country;
    } catch {
    }
  }
  return "ES";
}
var COMMON_COUNTRY_CODES = [
  { code: "ES", name: "Espa\xF1a", callingCode: "34" },
  { code: "PT", name: "Portugal", callingCode: "351" },
  { code: "FR", name: "Francia", callingCode: "33" },
  { code: "DE", name: "Alemania", callingCode: "49" },
  { code: "IT", name: "Italia", callingCode: "39" },
  { code: "GB", name: "Reino Unido", callingCode: "44" },
  { code: "US", name: "Estados Unidos", callingCode: "1" },
  { code: "MX", name: "M\xE9xico", callingCode: "52" },
  { code: "AR", name: "Argentina", callingCode: "54" },
  { code: "CO", name: "Colombia", callingCode: "57" }
];

export {
  normalizePhone,
  validatePhone,
  getCallingCode,
  parsePhone,
  detectCountryFromLocale,
  COMMON_COUNTRY_CODES
};
